export default __webpack_public_path__ + "static/media/register1.83050485.jpg";